import React from 'react';
import { Tabs } from 'antd';
import UsersScreen from '../Users/UsersScreen';
import Meta from '../../components/Meta';
import './SettingsScreen.less';

const SettingsScreen: React.FC = () => {
  const activeKey = 'users';

  const items = [
    {
      key: 'users',
      label: 'Users',
      children: <UsersScreen />,
    },
  ];

  return (
    <>
      <Meta name="Cirra AI - Settings" />
      <div className="main-screen-element" id="settings-screen">
        <Tabs defaultActiveKey={activeKey} items={items} />
      </div>
    </>
  );
};

export default SettingsScreen;
